import { Typography } from '@mui/material';

export const Dots = () => {
  return (
    <Typography
      variant='body4'
      sx={{
        mt: 'auto',
        color: 'primary.main',
      }}
    >
      ...
    </Typography>
  );
};
